import { Box, Card } from '@mui/material';
import React from 'react';
import Chart from 'react-apexcharts';
import { AppUtils } from '../../../utils/appUtils';
import MessageBlock from '../../../pages/admin/components/message-block/MessageBlock';
import { NO_RECORDS_FOUND } from '../../../utils/constants';

const ChartDataByMonth = ({ chartDataByMonth }) => {
  if (!chartDataByMonth?.GENDER_WISE_DATA) {
    return null; // Ensure the data is available before rendering
  }

  const months = [
    "SHRAWAN", "BHADRA", "ASHWIN", "KARTIK", "MANGSIR", "POUSH",
    "MAGH", "FALGUN", "CHAITRA", "BAISAK", "JESTHA", "ASHAD"
  ];

  const nepaliMonths = [
    "साउन", "भदौ", "आश्विन", "कार्तिक", "मंसिर", "पौष",
    "माघ", "फागुन", "चैत", "बैशाख", "जेष्ठ", "आषाढ"
  ];

  const genderWiseData = chartDataByMonth.GENDER_WISE_DATA;

  // Filter months where all gender values are zero
  const filteredMonths = months.filter((month, index) => {
    const male = genderWiseData.MALE[month] || 0;
    const female = genderWiseData.FEMALE[month] || 0;
    const other = genderWiseData.OTHER[month] || 0;
    return male !== 0 || female !== 0 || other !== 0;
  });

  const filteredNepaliMonths = filteredMonths.map(month => {
    const index = months.indexOf(month);
    return nepaliMonths[index];
  });

  const seriesData = [
    {
      name: 'पुरुष',
      data: filteredMonths.map(month => genderWiseData.MALE[month] || 0),
    },
    {
      name: 'महिला',
      data: filteredMonths.map(month => genderWiseData.FEMALE[month] || 0),
    },
    {
      name: 'अन्य',
      data: filteredMonths.map(month => genderWiseData.OTHER[month] || 0),
    },
  ];

  const chartOptions = {
    chart: {
      type: 'bar',
      stacked: true,
      height: 350,
    },
    plotOptions: {
      bar: {
        horizontal: false,
      },
    },
    xaxis: {
      categories: filteredNepaliMonths,
      title: {
        text: "महिना"
      }
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: (val) => `${AppUtils.replaceWithNepaliDigit(val)} जना`,
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => `${AppUtils.replaceWithNepaliDigit(val)} जना`,
    },
    yaxis: {
      title: {
        text: "जम्मा संख्या"
      }
    },
    title: {
      text: "चालु आ. व. को लिङ्ग अनुसार सेवाग्राही विवरण",
      align: "center",
      style: {
        fontSize: "15px",
      },
    },
    legend: {
      position: 'top',
    },
    fill: {
      opacity: 1,
    },
  };

  return (
    <Box mt={2}>
      <Card>
        {filteredMonths.length > 0 ? <Chart
          options={chartOptions}
          series={seriesData}
          type="bar"
          height={350}
        /> : (
          <MessageBlock text={NO_RECORDS_FOUND} />
        )}
      </Card>
    </Box>
  );
};

export default ChartDataByMonth;
